import { Avatar } from '@material-ui/core';
import React from 'react';

export function FlagAvatar({
  height,
  width,
}: {
  height: string;
  width: string;
}) {
  const countryId = process.env.NEXT_PUBLIC_COUNTRY_ID;
  return (
    <Avatar
      style={{ height, width }}
      alt={countryId === 'MX' ? "mexico's flag" : "chile's flag"}
      src={`/assets/locales/${countryId}/flag.svg`}
    />
  );
}
